<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm-title">Acknowledgements</h2>
<p class="noindent">The author would like to express his personal thanks to the following: The National Archives, Imperial War Museum, Aberdeen City and Aberdeenshire Archives, Manx National Heritage Library and Archives, Newcastle Local Studies Library, Gerry Jackson, BBC Look North, BBC Radio Norfolk, MVC Studios, Norfolk Record Office, Lizzy Baker, Archives Lead, Tyne &amp; Wear Archives, German Occupation Museum, Guernsey, Milton Keynes Museum, Lieutenant Colonel Martin Valles, Kim Valles, David Hepworth, Derek Tree, John Warwicker, Richard Underwood, David Schrader, Tim Bennett, Steve and Eve Bacon, David and Christine Parmenter, Ian Johnson, Marc Hope, Richard Cobb, Ellengard Gertz, Oliver Rogge, Mark Cudworth, Susanne Köhler, Austin Ruddy, Michelle Bullivant, Henry Wilson, Matt Jones, Irene Moore, my old friends Stewart P. Evans, Bob Collis and James Hayward, my loving family and partner Fiona for all her love and support.</p>
<p class="indent">The author also would like to place on record his thanks to the many Second World War veterans of Britain, America, France, Belgium, Holland and Germany and their families who have shared their wartime stories, letters, memoirs and photographs with him over the years.</p>
<a id="page_vii"></a>
<div class="img_container">
<img alt="images" src="images/f0vii-01.jpg"/>
<p class="caption"><em class="italic"><span class="bold">‘The August Moon’</span></em> <span class="bold">Punch</span><em class="italic">, <span class="bold">21 August 1940.</span></em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?25731468